

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const Get_M_ELEC_WorkSubType_SelectDataAPI = createAsyncThunk("Get_M_ELEC_WorkSubType_SelectData", async ({ data }) => {
    const {
        M_ELEC_WorkTypeID,
        M_ELEC_WorkSubTypeID,
        WorkSubTypeName,
        M_UserID,
        token,
        From,
        To,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_WorkSubType_Select?M_ELEC_WorkSubTypeID=${M_ELEC_WorkSubTypeID}&M_ELEC_WorkTypeID=${M_ELEC_WorkTypeID}&WorkSubTypeName=${WorkSubTypeName}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Get_M_ELEC_WorkSubType_SelectDataSlice = createSlice({
    name: "Get_M_ELEC_WorkSubType_SelectData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_M_ELEC_WorkSubType_SelectDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_M_ELEC_WorkSubType_SelectDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Get_M_ELEC_WorkSubType_SelectDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_M_ELEC_WorkSubType_SelectDataReducer = Get_M_ELEC_WorkSubType_SelectDataSlice.reducer



// InsertUpdate Table Data

export const Post_M_ELEC_WorkSubType_InsertUpdateAPI = createAsyncThunk("Post_M_ELEC_WorkSubType_InsertUpdate", async ({ data }) => {
    const {
        M_ELEC_WorkSubTypeID,
        M_ELEC_WorkTypeID,
        WorkSubTypeName,
        M_UserID,
        Flag,
        token,
        setLoading,
        handleIsPost,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    formdata.append("M_ELEC_WorkSubTypeID", M_ELEC_WorkSubTypeID);
    formdata.append("M_ELEC_WorkTypeID", M_ELEC_WorkTypeID);
    formdata.append("WorkSubTypeName", WorkSubTypeName);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)

    let url
    url = `${BaseUrl}/Electrical/Post_M_ELEC_WorkSubType_InsertUpdate`

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                toastSuccesss(result.message)
                handleOnCloseClick()
                setLoading(false)
                return result.data
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const Post_M_ELEC_WorkSubType_InsertUpdateSlice = createSlice({
    name: "Post_M_ELEC_WorkSubType_InsertUpdate",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Post_M_ELEC_WorkSubType_InsertUpdateAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Post_M_ELEC_WorkSubType_InsertUpdateAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Post_M_ELEC_WorkSubType_InsertUpdateAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const Post_M_ELEC_WorkSubType_InsertUpdateReducer = Post_M_ELEC_WorkSubType_InsertUpdateSlice.reducer



// Delete Table Data

export const M_ELEC_WorkSubType_DeleteAPI = createAsyncThunk("M_ELEC_WorkSubType_Delete", async ({ data }) => {
    const {
        M_ELEC_WorkSubTypeID,
        M_UserID,
        handleIsPost,
        token,
        handleDeleteCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ELEC_WorkSubTypeID", M_ELEC_WorkSubTypeID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/M_ELEC_WorkSubType_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
                handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                handleDeleteCloseClick()
            }
            return result

        })
})

const M_ELEC_WorkSubType_DeleteSlice = createSlice({
    name: "M_ELEC_WorkSubType_Delete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_ELEC_WorkSubType_DeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(M_ELEC_WorkSubType_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;

        });
        builder.addCase(M_ELEC_WorkSubType_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const M_ELEC_WorkSubType_DeleteReducer = M_ELEC_WorkSubType_DeleteSlice.reducer